/**
 * Created by Administrador on 29/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('excessLuggageTypeService', excessLuggageTypeService);

    excessLuggageTypeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function excessLuggageTypeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/excessLuggageTypes';
        var service = {
            getExcessLuggageTypes: getExcessLuggageTypes,
        }

        return service;

        function getExcessLuggageTypes(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.excessLuggageTypes : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };

})();
